export default __webpack_public_path__ + "static/media/AODG26844.634376f7.png";